.root {
    margin: 0px 20px 0px 20px;
    flex-direction: column;
    height: 100%;
    min-height: 40rem;
    @media only screen and (min-height: 800px) {
        min-height: 10rem;
    }
}

.animationRoot {
    margin: 0px 20px 0px 20px;
    flex-direction: column;
}

.styledInputWrapper {
    margin-bottom: 12px;
    width: 100%;
    z-index: var(--mantine-priority-lowest);
}

.styledInput {
    border-radius: var(--mantine-radius-sm);
    border: 1px solid var(--mantine-color-dark-3);
    background: var(--mantine-color-dark-5);
    font-size: var(--mantine-font-size-sm);
}

.styledInput:disabled {
    color: var(--mantine-color-dark-0);
}

.styledLabel {
    margin-bottom: 1rem;
}
